import { Component, HostListener, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AccountService, AppConfigService, ProfileModel } from "@app-cmc/core";
import { CFSConnectionService } from "@app-cmc/services";
import { OAuthEvent, OAuthService } from "angular-oauth2-oidc";
import { JwksValidationHandler } from "angular-oauth2-oidc-jwks";
import * as waves from "node-waves";
import { filter } from "rxjs/operators";
import { authConfig } from "./auth.config";

@Component({ selector: "app-clearline-marketing", templateUrl: "app.component.html", styleUrls: ["app.component.scss"] })
export class AppComponent implements OnInit {
  user: ProfileModel;

  get year() {
    return new Date().getFullYear();
  }

  title = this.configSvc.appData.title;
  patentNotice = this.configSvc.appData.patentNotice;

  @HostListener("window:beforeunload") beforeunload() {
    this.cfsConnectionService.handleOnBeforeLoad();
  }

  constructor(
    private router: Router,
    private oauthService: OAuthService,
    private accountService: AccountService,
    private configSvc: AppConfigService,
    private cfsConnectionService: CFSConnectionService
  ) {}

  ngOnInit() {
    this.configureOidc();
    //  this.authService.refreshToken();
    waves.init();
  }

  private async configureOidc() {
    const authConf: IAuthConfig = this.configSvc.appData.authConfig;
    this.oauthService.configure(authConfig(authConf));
    this.oauthService.setStorage(sessionStorage);
    this.oauthService.tokenValidationHandler = new JwksValidationHandler();

    const culture = "en-US";
    this.oauthService.customQueryParams = {
      ui_locales: culture,
      location: ""
    };

    // Process refreshUser query param:
    const url = new URL(window.location.href);
    const refreshUserQuery = url.searchParams.get("refreshUser");
    const posSystemId = url.searchParams.get("posSystemId") || sessionStorage.getItem("posSystemId");

    if (refreshUserQuery != null) {
      url.searchParams.delete("refreshUser");
      window.history.replaceState({}, document.title, url.toString());

      this.oauthService.logOut(true); // Clear Auth storage cache without redirect.
    }

    if (posSystemId) {
      this.oauthService.customQueryParams["posSystemId"] = posSystemId;
      sessionStorage.setItem("posSystemId", posSystemId);
    }

    this.oauthService.setupAutomaticSilentRefresh();

    this.oauthService.events
      .pipe(filter((e: OAuthEvent) => e.type === "session_terminated"))
      .subscribe(() => this.oauthService.initImplicitFlow());

    try {
      await this.oauthService.loadDiscoveryDocumentAndTryLogin();
      const user = this.accountService.user;

      this.accountService.refreshUser(user);

      const redirectPath = localStorage.getItem("redirectPath");
      if (redirectPath && this.accountService.isLoggedIn) {
        this.router.navigateByUrl(redirectPath);
        localStorage.removeItem("redirectPath");
      }
    } catch (error) {
      console.error(error);
    }
  }
}
